module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?cdac4fb864d0816f2cbef6c78d4f6490";